import React from 'react';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';

const OperationTag = ({ tipo, position = 'center' }) => {
    const TagPosition = position === 'right' 
        ? 'justify-end' 
        : position === 'left' 
            ? 'justify-start' 
            : 'justify-center';

    const isIngreso = tipo === '01';
    const isEgreso = tipo === '02';

    const tagStyle = isIngreso
        ? 'bg-gradient-to-r from-green-400 to-green-600 dark:from-green-500 dark:to-green-700'
        : isEgreso
            ? 'bg-gradient-to-r from-red-400 to-red-600 dark:from-red-500 dark:to-red-700'
            : 'bg-gray-300 dark:bg-gray-600';

    const label = isIngreso ? 'Ingreso' : isEgreso ? 'Egreso' : 'Desconocido';
    const Icon = isIngreso ? FaArrowDown : isEgreso ? FaArrowUp : null;

    return (
        <div className={`flex ${TagPosition} items-center`}>
            <span className={`text-sm font-bold ${tagStyle} text-white py-1 px-2 rounded-xl flex items-center gap-1 shadow-md`}>
                {Icon && <Icon size={18} />}
                {label}
            </span>
        </div>
    );
};

export default OperationTag;

